export const endpoints = {
     appointment: {
          additionalCharges: {
               delete: '/appointments/:id/additionalCharges/:xrefId',
          },
          attachment: '/appointments/:id/attachment',
          clear: '/appointments/:id/clear',
          downloadAttachment: '/appointments/:id/attachment/:attachmentId',
          formFieldEntries: '/appointments/:id/formFieldEntries/formId/:formId',
          deleteFormFieldEntries: '/appointments/:id/:formEntryId/delete',
          inventory: {
               add: '/appointments/:id/inventory/:invId',
               deleteToBeAdded: '/appointments/:id/inventory/:invId',
               new: '/appointments/:id/inventory',
               provision: '/appointments/:id/inventory/provision',
               remove: '/appointments/:id/inventory/:invId/remove',
               setToActive: '/appointments/:id/inventory/:invId/setactive',
               updateAttributes: '/appointments/:id/inventory/:invId/attributes',
          },
          list: '/appointments',
          ticketnotes: '/ticketnotes',
          timeEntry: {
               add: '/timeentries',
               editById: '/timeentries/:entryId',
               editByInfo: '/timeentries',
               deleteById: '/timeentries/:entryId',
               deleteByInfo: '/timeentries',
          },
          updateStatus: '/appointments/:id/status',
     },
     customerService: {
          failedRequests: '/customerservice/failedrequests',
     },
     inventory: {
          warehouse: {
               equipment: {
                    validate: '/warehouseinventory/equipment/:equipId/attribute/:attrId',
               },
          },
     },
     linecard: {
          comment: '/linecard/comment',
     },
     login: '/login',
     sync: {
          getUpdateBit: '/sync/status',
          resetUpdateBit: '/sync/status/reset',
          dynamic: '/sync/dynamic',
          config: '/sync/config',
          updateLastSyncTime: '/sync/time',
     },
};
